import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  desiredStoreOptionsRoot: {
    width: '100%',
  },
  optionsTitle: {
    fontSize: '18px',
    lineHeight: '26px',
    color: '#6F7878',
    fontWeight: 500,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '15px',
      lineHeight: '23px',
    },
  },
  optionStoreContainer: {
    marginTop: '5px',
  },
  optionStore: {
    textAlign: 'center',
    minWidth: '150px',
    padding: '15px 5px',
    border: '1px solid #ccc',
    marginRight: '15px',
    marginBottom: '10px',
    color: '#6F7878',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: '15px',
      lineHeight: '23px',
    },
  },
  optionStoreActive: {
    backgroundColor: '#D0111B',
    color: '#ffffff',
  },
}));

export default useStyles;
